import { useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const PLANS = [
  { key: "basic_monthly", name: "Basic" },
  { key: "avanzato_monthly", name: "Avanzato" },
  { key: "pro_monthly", name: "Pro" },
  { key: "business_monthly", name: "Business" },
];

export const AdminPlanButton = ({ restaurant, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const current = restaurant.subscription?.status === "active" ? restaurant.subscription.lookup_key : "free";

  const setPlan = async (key) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/users/${restaurant.owner_id}/plan`, { lookup_key: key });
      onChanged(restaurant.owner_id, data.subscription);
      toast.success(key === "free" ? `${restaurant.owner_email}: piano Free` : `${restaurant.owner_email}: piano ${data.subscription.name} omaggio attivo`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="text-amber-700 hover:bg-amber-50" title="Piano omaggio" data-testid={`admin-plan-${restaurant.id}`}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Gift className="h-4 w-4" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="admin-plan-menu">
        <DropdownMenuLabel className="text-xs text-gray-500">Piano omaggio (senza addebito)</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PLANS.map((p) => (
          <DropdownMenuItem key={p.key} onClick={() => setPlan(p.key)} className={current === p.key ? "font-semibold text-[#4a8a56]" : ""} data-testid={`admin-plan-${p.key}`}>
            {p.name}{current === p.key ? " ✓" : ""}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => setPlan("free")} className={current === "free" ? "font-semibold" : ""} data-testid="admin-plan-free">
          Free{current === "free" ? " ✓" : ""}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
